/* eslint-disable react/prop-types */
import React from 'react';
import { P } from '@contently/toolkit';
import { removeCentsAddCommas } from '../value/utils';

const RegularCell = ({ cell }) => {
  const value = Number(cell.value);
  return <P>${removeCentsAddCommas(value)}</P>;
};

export default RegularCell;



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_level_value/ContentSpendCell.jsx